import CantileverCard from 'components/CantileverCard'
import { CommentSection } from 'features/assetDatabase/components/notesAndComments/CommentSection'
import { NotesSection } from 'features/assetDatabase/components/notesAndComments/NotesSection'
import React from 'react'
import styled from 'styled-components'
import { GeckoUnit } from 'types'

const NotesAndCommentsContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`

export interface NotesCardProps {
  unit: GeckoUnit | undefined
  refreshData: () => Promise<void>
}

export const NotesCard: React.FC<NotesCardProps> = ({ unit, refreshData }) => {
  return (
    <CantileverCard>
      <CantileverCard.CardHeader leadingContent='Notes & Comments' />
      <CantileverCard.Section>
        <NotesAndCommentsContainer>
          <NotesSection unit={unit} refreshData={refreshData} />
          {unit && <CommentSection unit={unit} />}
        </NotesAndCommentsContainer>
      </CantileverCard.Section>
    </CantileverCard>
  )
}
